import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export type FormAction = 'save' | 'cancel';

@Injectable()
export class ContactDetailsService {
    readonly #isEditing = new BehaviorSubject<boolean>(false);
    isEditing$ = this.#isEditing.asObservable();

    readonly #canSave = new BehaviorSubject<boolean>(false);
    canSave$ = this.#canSave.asObservable();

    readonly #formAction = new Subject<FormAction>();
    formAction$ = this.#formAction.asObservable();

    updateEditing(isEditing: boolean) {
        this.#isEditing.next(isEditing);
    }

    updateCanSave(canSave: boolean) {
        this.#canSave.next(canSave);
    }

    performFormAction(action: FormAction) {
        this.#formAction.next(action);
    }
}
